import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltroModalItemInputProduto.vue?vue&type=template&id=2b297e24"
import script from "./RelatorioCargaDescargaListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports